import React, { useState } from 'react'
import { Modal } from 'react-bootstrap'
import { Trans, useTranslation } from 'react-i18next'
import { stripeUpdatePaymentMethodLink } from '../../../redux/actions/myAccountAction'
import { SUPPORT_EMAIL } from '../../../utils/config'
import '../modal.css'
import './overdue-invoice-modal.css'

interface OverdueInvoiceModalProps {
  show: boolean
}

const OverdueInvoiceModal: React.FC<OverdueInvoiceModalProps> = ({ show }) => {
  const { t } = useTranslation('plan')
  const [isLoading, setIsLoading] = useState(false)

  const handleUpdatePayment = async () => {
    setIsLoading(true)
    try {
      const session = await stripeUpdatePaymentMethodLink()
      if (session?.url) {
        window.location.href = session.url
      }
    } catch (error) {
      console.error('Error opening payment update:', error)
    } finally {
      setIsLoading(false)
    }
  }

  return (
    <div className='custom_modal'>
      <Modal
        show={show}
        // eslint-disable-next-line @typescript-eslint/no-empty-function
        onHide={() => {}}
        size='lg'
        aria-labelledby='overdue-invoice-modal'
        centered
        className='common_modal_main_div overdue-invoice-modal'
        backdrop='static'
        keyboard={false}
      >
        <Modal.Body className='mobile_align_div'>
          <div className='overdue-icon-container'>
            <div className='overdue-icon'>
              <svg width='28' height='28' viewBox='0 0 24 24' fill='none' xmlns='http://www.w3.org/2000/svg'>
                <rect x='1' y='4' width='22' height='16' rx='3' stroke='#E65100' strokeWidth='1.8' />
                <line x1='1' y1='9' x2='23' y2='9' stroke='#E65100' strokeWidth='1.8' />
                <line x1='5' y1='14' x2='11' y2='14' stroke='#E65100' strokeWidth='1.8' strokeLinecap='round' />
                <line x1='16' y1='17' x2='16' y2='11' stroke='#D32F2F' strokeWidth='1.8' strokeLinecap='round' />
                <circle cx='16' cy='8' r='0' fill='none' />
                <path d='M14.5 12.5L17.5 15.5M17.5 12.5L14.5 15.5' stroke='#D32F2F' strokeWidth='1.6' strokeLinecap='round' />
              </svg>
            </div>
          </div>
          <div className='modal_title_div overdue-title'>
            <h4 className='modal_heading'>{t('billingModals.overdue.title')}</h4>
          </div>
          <div className='overdue-content'>
            <p>{t('billingModals.overdue.body')}</p>
          </div>
          <div className='overdue-actions'>
            <button className='btn overdue-update-btn' onClick={handleUpdatePayment} disabled={isLoading}>
              {isLoading ? (
                <>
                  <span className='spinner-border spinner-border-sm me-2' role='status' aria-hidden='true'></span>
                  {t('billingModals.overdue.opening')}
                </>
              ) : (
                t('billingModals.overdue.updateCard')
              )}
            </button>
          </div>
          <div className='overdue-help'>
            <Trans
              t={t}
              i18nKey='billingModals.overdue.help'
              values={{ email: SUPPORT_EMAIL }}
              components={{ mail: <a href={`mailto:${SUPPORT_EMAIL}`} /> }}
            />
          </div>
        </Modal.Body>
      </Modal>
    </div>
  )
}

export default OverdueInvoiceModal
